import { render } from "./SegmentedGroup.vue?vue&type=template&id=1ffc39a7&scoped=true"
import script from "./SegmentedGroup.vue?vue&type=script&lang=js"
export * from "./SegmentedGroup.vue?vue&type=script&lang=js"

import "./SegmentedGroup.vue?vue&type=style&index=0&id=1ffc39a7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffc39a7"]])

export default __exports__